import { render, staticRenderFns } from "./StockFifoProductCard.vue?vue&type=template&id=ba1a8170&scoped=true&"
import script from "./StockFifoProductCard.vue?vue&type=script&lang=js&"
export * from "./StockFifoProductCard.vue?vue&type=script&lang=js&"
import style0 from "./StockFifoProductCard.vue?vue&type=style&index=0&id=ba1a8170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1a8170",
  null
  
)

export default component.exports